import contentfulGql from 'js/lib/contentfulGql';

import { entWebsiteBlockAssemblyFragment } from 'bundles/ent-website/queries/EntWebsiteBlockAssembly';
import { ctaFragment } from 'bundles/ent-website/queries/common';

export const entWebsiteH1H2CtaFragment = contentfulGql`#graphql
  fragment EntWebsiteH1H2Cta on EntWebsiteH1H2Cta {
    heading
    subheading
  }
`;

export const entWebsitePlanCardFragment = contentfulGql`#graphql
  ${ctaFragment}
  fragment EntWebsitePlanCard on EntWebsitePlanCard {
    topBorderColor
    title
    subtitle
    price
    priceSubtitle
    priceSubtitle2
    cta {
      ...Cta
    }
    benefitListCollection {
      items {
        headline
      }
    }
    bottomCta {
      ...Cta
    }
  }
`;

export const entWebsitePlanCardsColumnFragment = contentfulGql`#graphql
  ${entWebsitePlanCardFragment}
  fragment EntWebsitePlanCardsColumn on EntWebsitePlanCardsColumn {
    planCardsCollection {
      items {
        ...EntWebsitePlanCard
      }
    }
  }
`;

export const entWebsiteTwoColumnsFragment = contentfulGql`#graphql
  ${entWebsiteH1H2CtaFragment}
  ${entWebsitePlanCardsColumnFragment}
  fragment EntWebsiteTwoColumns on EntWebsiteTwoColumns {
    slug
    leftColumn {
      __typename
      ...EntWebsiteH1H2Cta
      ...EntWebsitePlanCardsColumn
    }
    rightColumn {
      __typename
      ...EntWebsiteH1H2Cta
      ...EntWebsitePlanCardsColumn
    }
  }
`;

export const entWebsiteBlockTwoColumnsQuery = contentfulGql`#graphql
  ${entWebsiteBlockAssemblyFragment}
  ${entWebsiteTwoColumnsFragment}
  query entWebsiteBlockTwoColumns($id: String!, $preview: Boolean, $locale: String!) {
    entWebsiteBlockAssembly(id: $id, preview: $preview, locale: $locale) {
      ...EntWebsiteBlockAssembly
      reference {
        __typename
        ...EntWebsiteTwoColumns
      }
    }
  }
`;
